import { redirect as redirectFn, type ToOptions } from "@tanstack/react-router";
import type { MemberRole } from "shared";
import { satisfiesRole } from "shared";
import { toast } from "sonner";
import type { RouterContext } from "@/routes/__root";

export async function restrictRoute(
  context: RouterContext,
  {
    requiredRole,
    redirect,
    message = "You do not have access to this page",
  }: {
    requiredRole: MemberRole;
    redirect: ToOptions;
    message?: string;
  },
) {
  const session = await context.queryClient.ensureQueryData(
    context.trpc.auth.session.queryOptions(),
  );
  if (!satisfiesRole(session.role, requiredRole)) {
    toast.error(message);
    throw redirectFn(redirect);
  }
}
